export default __webpack_public_path__ + "static/media/30.ca5f5119.png";